import { render, staticRenderFns } from "./AcademicLevelTable.vue?vue&type=template&id=2d395ade&scoped=true"
import script from "./AcademicLevelTable.vue?vue&type=script&lang=js"
export * from "./AcademicLevelTable.vue?vue&type=script&lang=js"
import style0 from "./AcademicLevelTable.vue?vue&type=style&index=0&id=2d395ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d395ade",
  null
  
)

export default component.exports